export default [
	'$timeout',
	function ($timeout) {
		var TIME_START_FLAG = 'T';

		function pad(number) {
			if (number < 10) {
				return '0' + number;
			}
			return number;
		}

		function setDateValueIfExist(ngModelDate, $elem) {
			if (ngModelDate) {
				var month = angular.element.datepicker.regional.hu.monthNames[parseInt(ngModelDate.substring(5, 7)) - 1];
				var dateValue = ngModelDate.substring(0, 4) + '. ' + month + ' ' + ngModelDate.substring(8, 10) + '.';
				$elem.find('input').val(dateValue);
			}
		}

		function link(scope, $elem) {
			// Apply jquery design datepicker to selected element.
			$timeout(function () {
				setDateValueIfExist(scope.target, $elem);
				if (window.datepickerDesignSelect) {
					window.datepickerDesignSelect($elem.find('input')[0], function () {
						// server format: "2017-10-21T22:00:00"
						var datepickerDate = angular.element(this).datepicker('getDate');
						var serverDateFormat = datepickerDate.getFullYear() + '-' + pad(datepickerDate.getMonth() + 1) + '-' + pad(datepickerDate.getDate()) + TIME_START_FLAG + pad(datepickerDate.getHours()) + ':' + pad(datepickerDate.getMinutes()) + ':' + pad(datepickerDate.getSeconds());
						scope.target = serverDateFormat;
						scope.$apply();
					});
				}
			});
		}

		return {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				target: '=ngModel',
				minDate: '@',
				maxDate: '@'
			},
			link: link,
			template: '<input class="datepicker input--220" ng-attr-data-min-date="{{minDate}}" ng-attr-data-max-date="{{maxDate}}" />'
		};
	}
];
